<!-- @veltra/icons generated sha256:0213412b84d00bb5 gen:8 source:src/svg/normal/bell.svg -->
<script setup lang="ts">
defineOptions({ name: 'Bell' })
</script>
<template>
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16">
    <path
      fill="currentColor"
      d="M8.5 2.027v-.533A.5.5 0 0 0 7.996 1a.497.497 0 0 0-.496.494v.533a4.5 4.5 0 0 0-4 4.473V11l-.9 1.2a.5.5 0 0 0 .4.8h2.55a2.5 2.5 0 0 0 4.9 0H13a.5.5 0 0 0 .4-.8l-.9-1.2V6.5a4.5 4.5 0 0 0-4-4.473m-4 9.306V6.5a3.5 3.5 0 1 1 7 0v4.833L12 12H4zM8 14a1.5 1.5 0 0 1-1.415-1h2.83A1.5 1.5 0 0 1 8 14"
    />
  </svg>
</template>
